import { GenericEditField, DisplayScope, EditFieldKind } from "../DTO/GenericDTO";

const content1 = `<h2>Eingangsfragen</h2>
<p>Mit wem führe ich das Gespräch</p>
<p>Wann wurde das Gespräch geführt?</p>
<p>Wer hat von uns an dem Gespräch teilgenommen?</p>
<p>Warum gerade jetzt?</p>
<p>Warum mit uns?</p>
<p>Was ist deine Rolle</p>`

const content2 = `<h2>Ziele und Erwartungen</h2>
<p>Welches Format ist angedacht (ganzheitl. FKE, Training, Workshop, Coaching)?</p>
<p>Was ist das Hauptziel des Seminars oder Workshops?</p>
<p>Welche konkreten Ergebnisse sollen am Ende erreicht sein?</p>
<p>Welche Erwartungen haben die Teilnehmer?</p>
<p>Gibt es messbare Erfolgskriterien?</p>

<h2>Zielgruppe</h2>
<p>Wer sind die Teilnehmer (Position, Abteilung, Vorkenntnisse)?</p>
<p>Wie viele Personen werden teilnehmen?</p>
<p>Gibt es besondere Bedürfnisse oder Einschränkungen?</p>

<h2>Rahmenbedingungen</h2>
<p>Wann soll die Veranstaltung stattfinden (Datum, Uhrzeit, Dauer)?</p>
<p>Wo findet sie statt (Ort, Online, Hybrid)?</p>
<p>Welche technischen Voraussetzungen sind vorhanden?</p>
<p>Gibt es Pausenregelungen oder Verpflegung?</p>
<p>Zwei Trainer OK oder gibt es eine Dissonanz?</p>

<h2>Inhalte und Methodik</h2>
<p>Welche Themen sollen behandelt werden?</p>
<p>Gibt es Inhalte, die besonders wichtig oder tabu sind?</p>
<p>Welche Methoden sind gewünscht (Vortrag, Gruppenarbeit, Rollenspiel)?</p>
<p>Sollen Materialien vorbereitet oder bereitgestellt werden?</p>

<h2>Organisation und Verantwortung</h2>
<p>Wer ist Ansprechpartner für organisatorische Fragen?</p>
<p>Wer übernimmt die Kommunikation mit den Teilnehmern?</p>
<p>Gibt es einen Zeitplan oder Meilensteine vorab?</p>
<p>Wer kümmert sich um die Nachbereitung?</p>

<h2>Kommunikation und Feedback</h2>
<p>Wie wird Feedback eingeholt?</p>
<p>Gibt es eine Evaluation des Seminars?</p>
<p>Sollen Teilnehmerzertifikate ausgestellt werden?</p>

<h2>Budget und Abrechnung</h2>
<p>Welches Budget steht zur Verfügung?</p>
<p>Wie erfolgt die Abrechnung?</p>
<p>Gibt es besondere Zahlungsmodalitäten?</p>

<h2>Vertragliches und rechtliches</h2>
<p>Gibt es / haben wir bereits einen Vertrag oder eine schriftliche Vereinbarung?</p>
<p>Wie wird mit vertraulichen Informationen umgegangen (Wer sendet das NDA)?</p>
<p>Was passiert bei kurzfristiger Absage oder Krankheit?</p>
`

const content3 = `<h2>Sonstiges</h2>
<p>Wir benötigen einen Styleguide und Logos im Vektor-Format</p>
<h2>Ergänzungsfragen</h2>
<p>Gibt es bereits Material (Führungsleitlinien, Trainingskonzept etc.), welches Sie uns zukommen lassen können?</p>
<p>Was darf auf keinen Fall passieren?</p>
<p>Mit was (Verhalten/Aktion) können wir Erwartungen (über-)treffen und überraschen?</p>
<h2>Ausgangsfragen</h2>
<p>Wer entscheidet über die Maßnahme</p>
<p>Was braucht die Person (der Personenkreis), um eine gute Entscheidungsgrundlage zu haben?</p>`

export const EventOrderClarificationFields: GenericEditField[] = [
  {
    title: 'Eingangsfragen',
    key1: 'clarification',
    key2: 'startingQuestions',
    scope: DisplayScope.templateAndSeminar,
    kind: EditFieldKind.textArea,
    default: content1,
  },
  {
    title: 'Fragen zur konkreten Maßnahme',
    key1: 'clarification',
    key2: 'actualScheme',
    scope: DisplayScope.templateAndSeminar,
    kind: EditFieldKind.textArea,
    default: content2,
  },
  {
    title: 'Sonstiges',
    key1: 'clarification',
    key2: 'misc',
    scope: DisplayScope.templateAndSeminar,
    kind: EditFieldKind.textArea,
    default: content3,
  },
];
